import './mail-askForHelp-workspace.ajscss';

import { MailTransferWorkspaceCtrl } from '@agent/agent-interface/contact-view/mail/mail-transfer-workspace.component';
import { IAgentConfigDeprecatedService } from '@agent/core/agent/agent-config-deprecated.service';
import { IEpticaDeprecatedService } from '@agent/core/channel-digit/mail/eptica/eptica-deprecated.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { ITransfer, TransferHistorySelectionStatus, TransferTarget } from '@agent/core/contact/transfer/models/transfer';
import { ITransferDeprecatedService } from '@agent/core/contact/transfer/transfer-deprecated.service';
import { IDirectoryService } from '@agent/core/search/directory.service';
import { ISearchService } from '@agent/core/search/search.service';
import { SessionDeprecatedService } from '@commons/core/auth/session-deprecated.service';
import { IEpticaExctractAttachment, IEpticaExtractAttachmentFrom } from '@commons/history/history-mail/models/eptica-extract';
import { ChannelDeprecatedImpl } from '@commons/models/channel';
import { IComponentOptions } from 'angular';
import { i18n } from 'i18next';

import { AppConf, EpticaService, LoaderDeprecatedService, MomentService, ProfileFacade, ToasterFacade } from '@contact/upgrade';

import templateUrl from './mail-askForHelp-workspace.template.html';

class MaiAskForHelpWorkspaceCtrl extends MailTransferWorkspaceCtrl {
  constructor(
    override readonly $i18next: i18n,
    override readonly sessionDeprecatedService: SessionDeprecatedService,
    override readonly appConf: AppConf,
    override readonly agentConfigDeprecatedService: IAgentConfigDeprecatedService,
    override readonly contactDeprecatedService: IContactDeprecatedService,
    override readonly epticaDeprecatedService: IEpticaDeprecatedService,
    override readonly transferDeprecatedService: ITransferDeprecatedService,
    override readonly search: ISearchService,
    override readonly directoryService: IDirectoryService,
    override readonly timeUtil: MomentService,
    override readonly loaderDeprecatedService: LoaderDeprecatedService,
    override readonly epticaService: EpticaService,
    override readonly toasterFacade: ToasterFacade,
    override readonly profileFacade: ProfileFacade
  ) {
    super(
      $i18next,
      sessionDeprecatedService,
      appConf,
      agentConfigDeprecatedService,
      contactDeprecatedService,
      epticaDeprecatedService,
      transferDeprecatedService,
      search,
      directoryService,
      timeUtil,
      loaderDeprecatedService,
      epticaService,
      toasterFacade,
      profileFacade
    );
    // override the type
    // we will use it to save the attachments in the eptica deprecated service
    // done in the MailTransferWorkspaceCtrl in the function this.mainCallbackAttachmentFiles
    // so when canceling ask for help we will remove them so they will not be displayed in the response field anymore (see MailAskForHelpActionsCtrl cancel function)
    this.fromType = IEpticaExtractAttachmentFrom.ASK_FOR_HELP;
  }

  override $onInit() {
    super.commonInit();
    this.mainPromise().then(request => {
      // manage Pjs' events
      request.addPJEventsForAskForHelp(this.mainCallbackAttachmentFiles);
    });
  }

  override $onDestroy(): void {
    this.mainPromise().then(request => {
      request.removePJEventsAskForHelp();
    });
  }

  override get transfer(): ITransfer {
    return this.transferDeprecatedService
      .getTransfer(this.transferKey)
      .filter(transfer => this.availableTargetTypes.some(type => type === transfer.targetType))
      .getOrElseFunc(() => {
        const transf = this.transferDeprecatedService.createTransfer(this.transferKey, ChannelDeprecatedImpl.INCOMING_MAIL);
        transf.targetType = TransferTarget.AGENT;
        this.onTargetChange();
        return transf;
      });
  }

  // overriding the method
  override updateHistorySelectionStatus(): void {
    switch (this.transfer.targetType) {
      case TransferTarget.CORRESPONDENT:
      case TransferTarget.FREE_NUMBER:
        this.transferDeprecatedService.updateHistorySelectionAbility(TransferHistorySelectionStatus.SELECTABLE);
        break;
      case TransferTarget.AGENT:
      case TransferTarget.AGENT_ASSISTANCE_BY_SKILL:
        this.transferDeprecatedService.updateHistorySelectionAbility(TransferHistorySelectionStatus.NONE_OR_ALL);
        break;
      default:
        this.transferDeprecatedService.updateHistorySelectionAbility(TransferHistorySelectionStatus.DISABLED);
    }
  }

  override initAvailableTypes(): void {
    this.availableTargetTypes.push(TransferTarget.AGENT);
    this.availableTargetTypes.push(TransferTarget.CORRESPONDENT);
    this.availableTargetTypes.push(TransferTarget.FREE_NUMBER);
    this.availableTargetTypes.push(TransferTarget.AGENT_ASSISTANCE_BY_SKILL);
  }

  // Open the Eptica dropzone
  override addPjs(): void {
    this.mainPromise().then(request => {
      request.simulateClickOnUploadAskForHelp();
    });
  }

  // send remove order to Eptica's dropzone
  override doRemoveLinkCallback(file: IEpticaExctractAttachment): void {
    this.mainPromise().then(request => {
      // manage Pjs' events
      request.removeAttachmentFileForAskForHelp(file);
    });
  }
}

export class MailAskForHelpWorkspace implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = [
    '$i18next',
    'sessionDeprecatedService',
    'appConf',
    'agentConfigDeprecatedService',
    'contactDeprecatedService',
    'epticaDeprecatedService',
    'transferDeprecatedService',
    'search',
    'directory',
    'momentService',
    'loaderDeprecatedService',
    'epticaService',
    'toasterFacade',
    'profileFacade',
    MaiAskForHelpWorkspaceCtrl,
  ];
}

export default 'contactMailAskForHelpWorkspace';
